import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

const _reports = [];
let _fetchedAll = false;

const sanitise = ({id, ...report}) => ({
    id: Number(id),

    ...report
});

let ReportStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return [..._reports];
    },
    getById: function(id) {
        id = Number(id);
        return _reports.find(function(e) { return e !== undefined && e.id === id; });
    },
    add: function(report) {
        report = sanitise(report);
        const index = _reports.findIndex(function(e) { return e !== undefined && e.id === report.id; });
        if (0 <= index) {
            _reports[index] = report;
        } else {
            _reports.push(report);
        }
    },
    remove: function(id) {
        const index = _reports.findIndex(function(e) { return e !== undefined && e.id === id; });
        if (0 <= index) {
            delete _reports[index];
        }
    },
    fetchedAll: () => (_fetchedAll)

});

ReportStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.REPORT_LIST:
            action.data.forEach(ReportStore.add);
            _fetchedAll = action.data.length === 0;
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_LIST_ERROR:
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_INFO:
            ReportStore.add(action.data);
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_INFO_ERROR:
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_SAVE:
            ReportStore.add(action.data);
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_UPDATE:
            ReportStore.add(action.data);
            ReportStore.emitChange();
            break;

        case ActionTypes.REPORT_DELETE:
            if (!!action.data.deleted) {
                ReportStore.remove(Number(action.data.id));
            }
            ReportStore.emitChange();
            break;

        default:
            break;

    }

});

export default ReportStore;
